import React, { useState } from 'react';
import { Card, Table, Button, Badge, Form } from 'react-bootstrap';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { CME_KHOA_DAO_TAO_API } from '../../../../utils/apiUrl';
import { DeleteSingle, Get, Post } from '../../../../utils/httpProvider';
import { messageToast, status200 } from '../../../../utils/define';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';
import CMEEventAddEditModal from './CMEEventAddEditModal';
import CMEEventImportModal from './CMEEventImportModal';
import CMEEventParticipantModal from './CMEEventParticipantModal';
import moment from 'moment';

const CMEEvent = () => {
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const [openModal, setOpenModal] = useState(false);
    const [selectedData, setSelectedData] = useState(null);

    const [openImportModal, setOpenImportModal] = useState(false);
    const [eventImport, setEventImport] = useState(null);

    const [openParticipantModal, setOpenParticipantModal] = useState(false);
    const [eventView, setEventView] = useState(null);

    const [openConfirmLockModal, setOpenConfirmLockModal] = useState(false);
    const [idWantLock, setIdWantLock] = useState('');
    const [lockEventName, setLockEventName] = useState('');

    // Fetch Events
    const { isLoading, data, refetch } = useQuery(
        ['cmeEventsData'],
        () => Get(CME_KHOA_DAO_TAO_API.GET_ALL),
        { keepPreviousData: true }
    );

    const deleteFunc = useMutation((id) => DeleteSingle(`${CME_KHOA_DAO_TAO_API.DELETE}/${id}`));
    const getByIdFunc = useMutation((id) => Get(`${CME_KHOA_DAO_TAO_API.GET_BY_ID}/${id}`));
    const lockFunc = useMutation((id) => Post(`${CME_KHOA_DAO_TAO_API.LOCK_EVENT}/${id}`));

    const handleAdd = () => {
        setSelectedData(null);
        setOpenModal(true);
    };

    const handleEdit = (item) => {
        getByIdFunc.mutate(item.id, {
            onSuccess: (res) => {
                setSelectedData(res);
                setOpenModal(true);
            },
            onError: (err) => {
                toast.error("Không thể lấy thông tin chi tiết: " + err.message);
            }
        });
    };

    const handleOpenImport = (item) => {
        setEventImport(item);
        setOpenImportModal(true);
    };

    const handleOpenParticipants = (item) => {
        setEventView(item);
        setOpenParticipantModal(true);
    };

    const handleLock = (id, name) => {
        setIdWantLock(id);
        setLockEventName(name);
        setOpenConfirmLockModal(true);
    };

    const acceptLock = () => {
        if (!idWantLock) return;
        lockFunc.mutate(idWantLock, {
            onSuccess: (res) => {
                if (res === true || res.status === status200) {
                    toast.success("Đã chốt khóa đào tạo thành công.");
                    refetch();
                } else {
                    toast.error("Lỗi khi chốt khóa đào tạo.");
                }
            }
        });
        setOpenConfirmLockModal(false);
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        if (!idWantDelete) return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201 || res === true) {
                    toast.success(messageToast.messageToastDeleteSuccess);
                    refetch();
                } else {
                    toast.error(res?.message || messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || messageToast.messageToastTryCatch);
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const events = data?.$values ? data.$values : data || [];

    // Filter Logic
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [yearFilter, setYearFilter] = useState('all');

    const filteredEvents = events.filter(item => {
        const name = item?.tenKhoaDaoTao || '';
        const matchSearch = !searchTerm || name.toLowerCase().includes(searchTerm.toLowerCase());
        
        const status = item?.trangThai?.toString() || '0';
        const matchStatus = statusFilter === 'all' || status === statusFilter;
        
        const itemYear = item?.tuNgay ? moment(item.tuNgay).year().toString() : '';
        const matchYear = yearFilter === 'all' || itemYear === yearFilter;
        
        return matchSearch && matchStatus && matchYear;
    });

    // Generate years for filter (from current year down to 3 years ago)
    const years = [];
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 5; i++) {
        years.push(currentYear - i);
    }

    return (
        <div className="container-fluid">
            <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-white border-bottom d-flex justify-content-between align-items-center py-3">
                    <h5 className="mb-0 text-primary font-weight-bold">
                        <i className="fas fa-graduation-cap mr-2"></i>Quản lý Khóa đào tạo & Cấp điểm tập trung
                    </h5>
                    <Button variant="primary" size="sm" onClick={handleAdd} className="shadow-sm">
                        <i className="fas fa-plus mr-1"></i>Tạo khóa đào tạo mới
                    </Button>
                </Card.Header>
                <Card.Body>
                    {/* Filter Bar */}
                    <div className="row mb-4 align-items-end bg-light p-3 mx-0 rounded border">
                        <div className="col-md-4">
                            <Form.Label className="small font-weight-bold text-muted">Tìm kiếm khóa đào tạo</Form.Label>
                            <Form.Control 
                                type="text" 
                                placeholder="Nhập tên khóa học..." 
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="border-0 shadow-sm"
                            />
                        </div>
                        <div className="col-md-3">
                            <Form.Label className="small font-weight-bold text-muted">Trạng thái</Form.Label>
                            <Form.Control as="select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="border-0 shadow-sm">
                                <option value="all">Tất cả trạng thái</option>
                                <option value="0">Đang chuẩn bị</option>
                                <option value="1">Đã hoàn thành</option>
                            </Form.Control>
                        </div>
                        <div className="col-md-3">
                            <Form.Label className="small font-weight-bold text-muted">Năm tổ chức</Form.Label>
                            <Form.Control as="select" value={yearFilter} onChange={(e) => setYearFilter(e.target.value)} className="border-0 shadow-sm">
                                <option value="all">Tất cả các năm</option>
                                {years.map(y => <option key={y} value={y.toString()}>{y}</option>)}
                            </Form.Control>
                        </div>
                        <div className="col-md-2">
                            <Button 
                                variant="light" 
                                className="w-100 shadow-sm border" 
                                onClick={() => {
                                    setSearchTerm('');
                                    setStatusFilter('all');
                                    setYearFilter('all');
                                }}
                            >
                                <i className="fas fa-undo mr-1"></i>Reset
                            </Button>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Table hover className="align-middle">
                            <thead className="bg-light text-muted text-uppercase" style={{ fontSize: '0.8rem' }}>
                                <tr>
                                    <th style={{ width: '50px' }}>STT</th>
                                    <th>Tên Khóa đào tạo / Hoạt động</th>
                                    <th style={{ width: '180px' }}>Thời gian</th>
                                    <th style={{ width: '100px' }}>Số tiết</th>
                                    <th style={{ width: '120px' }}>Trạng thái</th>
                                    <th style={{ width: '220px' }} className="text-center">Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan={6} className="text-center py-5">Đang tải dữ liệu...</td></tr>
                                ) : filteredEvents.length === 0 ? (
                                    <tr><td colSpan={6} className="text-center py-5 text-muted">Không tìm thấy khóa đào tạo nào phù hợp với bộ lọc</td></tr>
                                ) : (
                                    filteredEvents.map((item, idx) => (
                                        <tr key={item.id}>
                                            <td className="font-weight-bold text-muted">{idx + 1}</td>
                                            <td>
                                                <div className="font-weight-bold text-dark">{item.tenKhoaDaoTao}</div>
                                                <small className="text-muted"><i className="fas fa-map-marker-alt mr-1"></i>{item.diaDiem || 'N/A'}</small>
                                            </td>
                                            <td>
                                                <div style={{ fontSize: '0.85rem' }}>
                                                    <div>Từ: {item.tuNgay ? moment(item.tuNgay).format('DD/MM/YYYY') : '-'}</div>
                                                    <div>Đến: {item.denNgay ? moment(item.denNgay).format('DD/MM/YYYY') : '-'}</div>
                                                </div>
                                            </td>
                                            <td className="text-center font-weight-bold">{item.soTiet}</td>
                                            <td>
                                                {item.trangThai === 1 ? 
                                                    <Badge pill variant="success">Đã hoàn thành</Badge> : 
                                                    <Badge pill variant="warning text-white">Đang chuẩn bị</Badge>
                                                }
                                            </td>
                                            <td className="text-center">
                                                <div className="d-flex flex-column">
                                                    <div className="mb-1">
                                                        <Button variant="outline-info" size="sm" className="mr-1" style={{ fontSize: '0.75rem' }} onClick={() => handleOpenParticipants(item)}>
                                                            <i className="fas fa-list mr-1"></i>Danh sách
                                                        </Button>
                                                        {item.trangThai === 0 && (
                                                            <Button variant="outline-primary" size="sm" style={{ fontSize: '0.75rem' }} onClick={() => handleOpenImport(item)}>
                                                                <i className="fas fa-file-import mr-1"></i>Import điểm
                                                            </Button>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {item.trangThai === 0 && (
                                                            <Button variant="link" className="text-success p-0 mr-2 font-weight-bold" style={{ fontSize: '0.8rem' }} onClick={() => handleLock(item.id, item.tenKhoaDaoTao)}>Chốt</Button>
                                                        )}
                                                        <Button variant="link" className="text-info p-0 mr-2" style={{ fontSize: '0.8rem' }} onClick={() => handleEdit(item)}>Sửa</Button>
                                                        <Button variant="link" className="text-danger p-0" style={{ fontSize: '0.8rem' }} onClick={() => deleteAction(item.id, item.tenKhoaDaoTao)}>Xóa</Button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
            </Card>

            <ConfirmModal
                isOpen={openConfirmDeleteModal}
                confirmType="delete"
                handleAccept={acceptDelete}
                handleCancel={() => setOpenConfirmDeleteModal(false)}
                content={`Bạn có chắc chắn muốn xóa khóa đào tạo: "${confirmDelMessage}"? Việc này sẽ không ảnh hưởng đến các điểm đã cấp trong quá khứ.`}
            />

            <CMEEventAddEditModal
                isOpen={openModal}
                handleClose={() => setOpenModal(false)}
                data={selectedData}
                refetch={refetch}
            />

            <CMEEventImportModal
                isOpen={openImportModal}
                handleClose={() => setOpenImportModal(false)}
                eventData={eventImport}
            />

            <CMEEventParticipantModal
                isOpen={openParticipantModal}
                handleClose={() => setOpenParticipantModal(false)}
                eventData={eventView}
            />

            <ConfirmModal
                isOpen={openConfirmLockModal}
                confirmType="confirm"
                handleAccept={acceptLock}
                handleCancel={() => setOpenConfirmLockModal(false)}
                content={`Bạn có chắc chắn muốn CHỐT khóa đào tạo: "${lockEventName}"? Sau khi chốt, bạn sẽ không thể Import thêm điểm.`}
            />
        </div>
    );
};

export default CMEEvent;
